export default (https) => ({
  async getList(params = []) {
    const queryString = params
      .filter(p => p.value !== null && p.value !== undefined && p.value !== '')
      .map(p => `${encodeURIComponent(p.key)}=${encodeURIComponent(p.value)}`)
      .join('&');
    const response = await https.get(`/fulfillment-costs?${queryString}`);
    return response.data;
  },

  // Upsert the fulfillment-cost profile for one box (keyed by box_product_id)
  async save(payload) {
    const response = await https.post('/fulfillment-costs', payload);
    return response.data;
  },
});
